import React from 'react'
import {LoaderSection} from "../../loader/Loader";
import {UserItem} from "./UserItem";
import {IChatGroupItem} from "../../../../types/chat";
import {readAllMsg} from "../../../../services/chatSvc";

type ChatUsersProps = {
  chats: any
  chatsIsLoading: boolean
  searchChat: string
  setSearchChat: (value: string) => void
  setSelectedUser: (value: IChatGroupItem) => void
  selectedUser: IChatGroupItem
}

export const ChatUsers = ({
                            chats,
                            chatsIsLoading,
                            searchChat,
                            setSearchChat,
                            setSelectedUser,
                            selectedUser
                          }: ChatUsersProps) => {
  return (
      <div className="flex-column flex-lg-row-auto w-100 w-lg-300px w-xl-400px mb-10 mb-lg-0">
        <div className="card card-flush">
          <div className="card-header pt-7" id="kt_chat_contacts_header">
            <form className="w-100 position-relative" autoComplete="off"><i
                className="ki-duotone ki-magnifier fs-2 text-lg-1 text-gray-500 position-absolute top-50 ms-5 translate-middle-y"><span
                className="path1"></span><span className="path2"></span></i>
              <input type="text" onChange={(e) => setSearchChat(e.target.value)} value={searchChat}
                     className="form-control form-control-solid px-15"
                     name="search"
                     placeholder="Qidiruv..."
                     data-temp-mail-org="0"/>
            </form>
          </div>

          <div className="card-body py-0" id="kt_chat_contacts_body">
            <div className="scroll-y me-n5 pe-5 h-200px h-lg-auto" data-kt-scroll="true"
                 data-kt-scroll-activate="{default: false, lg: true}" data-kt-scroll-max-height="auto"
                 data-kt-scroll-dependencies="#kt_header, #kt_toolbar, #kt_footer, #kt_chat_contacts_header"
                 data-kt-scroll-wrappers="#kt_content, #kt_chat_contacts_body" data-kt-scroll-offset="0px">
              {chatsIsLoading ? (
                  <LoaderSection height={"10vh"}/>
              ) : chats?.data?.length === 0 ? (
                  <div
                      className={"d-flex text-gray-500 user-select-none justify-content-center align-items-center"}
                      style={{
                        height: "10vh"
                      }}>
                    <p>Chatlar yo'q</p>
                  </div>
              ) : (
                  chats?.data?.map((userChat, index) => (
                      <div key={index} className={"cursor-pointer"} onClick={() => {
                        setSelectedUser(userChat)
                        userChat?.message_count && readAllMsg(userChat?.last_message?.id)
                      }}>
                        <UserItem selectedUser={selectedUser as IChatGroupItem} data={userChat}/>
                      </div>
                  ))
              )}
            </div>
          </div>
        </div>
      </div>
  )
}
